export const API_SUB_DIRECTORY = process.env.REACT_APP_API_SUB_DIRECTORY;
export const API_VERSION = process.env.REACT_APP_API_VERSION;

export const API_MAP_STATUS = `/${API_SUB_DIRECTORY}/${API_VERSION}/mapstatuses`;

//認
export const API_AUTH = `/${API_SUB_DIRECTORY}/${API_VERSION}/authentications?target=admin`;
export const API_AUTH_CURRENT = `/${API_SUB_DIRECTORY}/${API_VERSION}/authentications/current`;
//バンドル
export const API_BUNDLES = `/${API_SUB_DIRECTORY}/${API_VERSION}/bundles`;

//ログ
export const API_LOGS = `/${API_SUB_DIRECTORY}/${API_VERSION}/logs`;
//リージョン
export const API_REGIONS = `/${API_SUB_DIRECTORY}/${API_VERSION}/regions`;
//空き状況
export const API_OPENINGS = `/${API_SUB_DIRECTORY}/${API_VERSION}/openings`;
//予約
export const API_TICKETS = `/${API_SUB_DIRECTORY}/${API_VERSION}/tickets`;
//スケジュール
export const API_SCHEDULES = `/${API_SUB_DIRECTORY}/${API_VERSION}/schedules`;
//ユーザ
export const API_USERS = `/${API_SUB_DIRECTORY}/${API_VERSION}/users`;
//ユーザタイプ
export const API_USER_TYPES = `/${API_SUB_DIRECTORY}/${API_VERSION}/usertypes`;

//アイテム全部
export const API_ITEMS = `/${API_SUB_DIRECTORY}/${API_VERSION}/items`;
export const API_AREAS = `/${API_SUB_DIRECTORY}/${API_VERSION}/areas`;

//アンケート
export const API_QUESTIONNAIRES = `/${API_SUB_DIRECTORY}/${API_VERSION}/questionnaires`;
//セッティング
export const API_SETTINGS = `/${API_SUB_DIRECTORY}/${API_VERSION}/settings`;

//license
export const API_LICENSE = process.env.PUBLIC_URL + '/LICENSE.txt';


// WEBPACK FOOTER //
// ./src/constants/Api.js